// import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

// import { ApiService } from '../services/api.service';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { Component, ElementRef, OnInit, ViewChild, EventEmitter, Output, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, AbstractControl,Validators } from '@angular/forms';
// import { GlobalService } from '../services/global.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiService } from 'src/app/services/api.service';
import { GlobalService } from 'src/app/services/global.service';

@Component({
  selector: 'app-form-modal',
  templateUrl: './form-modal.component.html',
  styleUrls: ['./form-modal.component.scss'],
})
export class FormModalComponent implements OnInit {

  @Input() initiator:string = "";
  @Input() urlId:string = "";

  addSoundTextForm!: FormGroup;
  @ViewChild('fileInput') fileInput: ElementRef | undefined;
  isRecording: boolean = false;
  recordingStates: boolean[] = [];
  playingStates: boolean[] = [];
  stoppingStates: boolean[] = [];
  fileInputs: any[] = [];
  filesSelected: boolean[] = [];
  isFileSelected: boolean[] = [];
  mediaRecorder: any;
  audioChunks: any[] = [];
  audioBlobs: (Blob | null)[] = [];
  recordedAudioUrls: string[] = [];
  audioInstance: HTMLAudioElement | null = null;

  mispronounced_words: any;

  // @Output() dataUpdated = new EventEmitter<{ mispronouncedWords: string; not_recorded_mispronounced_words: string }>();



  formData = {
    text: '',
    language: 'nl',
    type: 'prioritize_text',
    usedForInterpretation: false,
  };

  constructor(private modalCtrl: ModalController,private fb: FormBuilder,private apiService:ApiService,private router:Router,private globalService:GlobalService,private alertController: AlertController) {
    this.addSoundTextForm = this.fb.group({
      soundTextArray: this.fb.array([])
    });

    this.addFormEntry(); // Add one default entry
  }
  ngOnInit(){
    console.log(this.initiator)
    console.log(this.urlId)
    this.resetForm();
  }

  ionViewWillEnter() {
    this.resetForm();
  }


  get soundTextArray() {
    return this.addSoundTextForm.get('soundTextArray') as FormArray;
  }

  addFormEntry() {
    const formEntry = this.fb.group({
      message: ['',[Validators.required]],
      lang: ['nl'],
      type: ['prioritize_text'],
      isForInterpretation: [false],
      addTextOnly: [false],
      audioFile: [null],
    });

    this.soundTextArray.push(formEntry);
    this.recordingStates.push(false);
    this.playingStates.push(false);
    this.stoppingStates.push(false);
    this.fileInputs.push(null); // Initialize fileInputs array
  }

  removeFormEntry(index: number) {
    this.soundTextArray.removeAt(index);

    this.recordingStates.splice(index, 1);
    this.playingStates.splice(index, 1);
    this.stoppingStates.splice(index, 1);
    this.fileInputs.splice(index, 1);
  }

  async showAlertOfPost() { // Type wordsList as an array of strings
    const alert = await this.alertController.create({
        header: 'Data added successfully !!!',
        cssClass: 'custom-alert',
        message:"", // Use a function to format the list
        buttons: ['OK'] // Add an OK button to close the alert
    });

    await alert.present();
  }


  goToMenu() {
    this.router.navigate(['/menu']);
  }

  closeModal(target:string) {
    if(target=='save'){

      if(this.initiator && this.initiator == 'modelinferencing'){
        
        let data = {
          soundTextArray:this.soundTextArray.value,
          audioBlobs: this.audioBlobs
        }
        this.modalCtrl.dismiss(data);    
      }
      else{
        this.modalCtrl.dismiss();    
      }
    }else{
      this.modalCtrl.dismiss();    
    }
  }

  saveData() {
    console.log(this.formData);
    this.modalCtrl.dismiss(this.formData);
  }

  clearFileInput(i: number) {
    this.toggleIsForInterpretation(i,true);

    this.soundTextArray.at(i).get('audioFile')?.setValue(null); // Clear the stored file
    if (this.fileInputs[i]) {
      this.fileInputs[i].value = ''; // Clear the file input visually
    }

    this.filesSelected[i] = false;
    this.recordingStates[i] = false;
    this.stoppingStates[i] = false;
    this.playingStates[i] = false;

    

    
  }


  async onSubmit() {
    try {
      this.globalService.storeDataLoading();
      let processedCount = 0; // Counter for processed requests
      let showPopup = false;
      let mispronounced_words: string[] = [];
      let not_recorded_mispronounced_words: string[] = [];

  
      if (this.addSoundTextForm.valid) {
        const formArray = this.soundTextArray.controls;
        const totalRequests = formArray.length;
  
        formArray.forEach((control: AbstractControl, index: number) => {
          const formGroup = control as FormGroup;
          const formValue = formGroup.value;
          const formData = new FormData();
  
          // Case: No audio file uploaded and no recorded blob exists
          if (formValue.audioFile == null && this.audioBlobs[index] == null) {
            const TextInfo = {
              Text: formValue.message,
              Type: formValue.type,
              Language: formValue.lang,
            };
            formData.append('TextInfo', JSON.stringify(TextInfo));
            this.apiService.addText(formValue,this.urlId).subscribe(
              async response => {
                console.log('Text only added successfully!!!', response);
                processedCount++;
                // mispronounced_words.push(formValue.message);
                // not_recorded_mispronounced_words.push(formValue.message);
                // await checkAndShowPopup();
                console.log("Misspronounced words are:",mispronounced_words)
              },
              async error => {
                console.error('Adding Text error:', error);
                processedCount++;
                // await checkAndShowPopup();
              }
              );
          }
          // Case: No audio file uploaded but a recorded blob exists
          else if (formValue.audioFile == null && this.audioBlobs[index] != null) {
            const blob = this.audioBlobs[index];
            if (blob !== null) {  // Alternatively: if (this.audioBlobs[index] instanceof Blob)
              formData.append('AudioFile', blob,'apple.mp3');
            } else {
              console.error('No audio file available at index', index);
            }
            const TextInfo = {
              Text: formValue.message,
              Type: formValue.type,
              Language: formValue.lang,
            };
            formData.append('TextInfo', JSON.stringify(TextInfo));
            formData.append('IsForInterpretation', formValue.isForInterpretation.toString());
            formData.append('Usable', 'true');
  
            this.apiService.addTextWithAudio(formData).subscribe(
              async response => {
                console.log('Text With Audio added successfully!!!', response);
                // mispronounced_words.push(formValue.message);
                processedCount++;
                // await checkAndShowPopup();
                // Clear the blob for this index
                this.audioBlobs[index] = null;
                this.audioBlobs = this.audioBlobs.filter(blob => blob !== null);
                this.clearFileInput(index);

              },
              async error => {
                console.error('Adding Text error:', error);
                processedCount++;
                //  await checkAndShowPopup();
              }
            );
          }
          // Case: Audio file is provided (via upload)
          else {
            formData.append('AudioFile', formValue.audioFile);
            const TextInfo = {
              Text: formValue.message,
              Type: formValue.type,
              Language: formValue.lang,
            };
            formData.append('TextInfo', JSON.stringify(TextInfo));
            formData.append('IsForInterpretation', formValue.isForInterpretation.toString());
            formData.append('Usable', 'true');
  
            this.apiService.addTextWithAudio(formData).subscribe(
              async response => {
                console.log('Text With Audio added successfully!!!', response);
                // mispronounced_words.push(formValue.message);
                processedCount++;
                // await checkAndShowPopup();
                // Clear the blob for this index
                this.audioBlobs[index] = null;
                this.audioBlobs = this.audioBlobs.filter(blob => blob !== null);
              },
              async error => {
                console.error('Adding Text error:', error);
                processedCount++;
                // await checkAndShowPopup();
              }
            );
          }
        });

        // const checkAndShowPopup = async () => {
        //   if (processedCount === totalRequests) {
        //     showPopup = true;
        //     if (showPopup) {
        //       this.showAlertOfPost();  // Show the popup once all requests are processed



        //       // console.log("Mispronounced words are:", mispronounced_words.join(', '));
        //       // console.log("Not recorded Mispronounced words are:", not_recorded_mispronounced_words.join(', '));


        //       // this.dataUpdated.emit({
        //       //   mispronouncedWords: mispronounced_words.join(', '),
        //       //   not_recorded_mispronounced_words: not_recorded_mispronounced_words.join(', ')
        //       // });


              
        //     }
        //   }
        // }

        setTimeout(()=>{
          this.closeModal('save')
        },0)
  
        // this.resetForm();
      }
      
      

      this.globalService.dismissLoading();
    } catch (error) {
      console.log('Form is invalid');

      
    }
  }


  resetForm() {
    // Clear all entries in the FormArray
    while (this.soundTextArray.length !== 0) {
      this.soundTextArray.removeAt(0);
    }
  
    // Add a fresh default entry
    this.addFormEntry();
  
    // Clear any file input manually
    const fileInputs = document.querySelectorAll('input[type="file"]') as NodeListOf<HTMLInputElement>;
    fileInputs.forEach(fileInput => {
      fileInput.value = '';
    });
  }


  onFileSelected(event: any, index: number) {
    const file = event.target.files[0];
    this.soundTextArray.at(index).patchValue({ audioFile: file });
    this.fileInputs[index] = event.target;
    this.filesSelected[index] = true;
  }

  onToggleChange(event: any, index: number, field: string) {
    this.soundTextArray.at(index).patchValue({ [field]: event.detail.checked });
  }

  goBack(){
    this.router.navigate(['/home']);
  }


  async confirmLogout() {
    const alert = await this.alertController.create({
          header: 'Confirm Logout',
          message: 'Are you sure you want to log out?',
          buttons: [
              {
                  text: 'Cancel',
                  role: 'cancel',
                  handler: () => {
                      // Do nothing when the user cancels
                  }
              },
              {
                  text: 'Logout',
                  handler: async () => {
                      // this.stopRecordingOnly();
                      await this.LogoutFunction();
                  }
              }
          ]
      });

      await alert.present();
    // }else{
    //   await this.LogoutFunction();
    // }
}

async LogoutFunction(){

    try{
        this.globalService.logoutLoading();
        const res:any = await this.apiService.logoutUser().toPromise();
            

        localStorage.removeItem('authenticationKey');
        localStorage.removeItem('accent');
        localStorage.removeItem('age');
        localStorage.removeItem('gender');
        localStorage.removeItem('userId');
        localStorage.removeItem('userName');
        localStorage.removeItem('language');

        localStorage.removeItem('searchedText');
        localStorage.removeItem('selectedModel');
        localStorage.removeItem('selectedModelLanguageForTTS');
        localStorage.removeItem('selectedOptionUser');
        localStorage.removeItem('textCategory');
        localStorage.removeItem('totalCountData');
        localStorage.removeItem('usersList');
        localStorage.removeItem('userRole');

        this.globalService.dismissLoading();
      
        this.router.navigate(['login']);



      
    
    }catch(error){
      console.log("Error:", error);
      // this.globalService.dismissLoading();
      this.router.navigate(['login']);

    }  
  };


  toggleIsForInterpretation(index: number,val:boolean) {
    const control = this.soundTextArray.at(index).get('isForInterpretation');
    if (control) {
      control.setValue(val); // Set the value to false explicitly
      console.log(this.soundTextArray.value); // Check the value (optional)
    }
  }


  startRecording(index: number) {

    this.toggleIsForInterpretation(index,false);

    this.recordingStates[index] = true;
    this.playingStates[index] = false;
    navigator.mediaDevices.getUserMedia({ audio: true })
      .then((stream) => {
        this.isRecording = true;
        this.mediaRecorder = new MediaRecorder(stream);
        this.audioChunks[index] = [];  // Initialize chunk array for the current recording index
        this.mediaRecorder.start();

        this.mediaRecorder.ondataavailable = (event: { data: any; }) => {
          this.audioChunks[index].push(event.data);
        };

        this.mediaRecorder.onstop = () => {
          const audioBlob = new Blob(this.audioChunks[index], { type: 'audio/wav' });
          this.audioBlobs[index] = audioBlob;  // Save blob for later sending
          const audioUrl = URL.createObjectURL(audioBlob);
          this.recordedAudioUrls[index] = audioUrl;  // Save the URL for playback
        };
      })
      .catch((error) => {
        console.error('Error accessing microphone:', error);
      });
  }


  stopRecording(index: number) {
    this.recordingStates[index] = false;
    this.playingStates[index] = false;
    this.stoppingStates[index] = true;
    // this.isRecording = false;
    // this.endClick = true;
    // this.startClick = false;
    if (this.mediaRecorder) {
        this.mediaRecorder.stop();
      }
    // setTimeout(() => {
    //   this.playRecording(index);
    // }, 500);
  }


  stopPlaying(index: number) {
    if (this.audioInstance && this.audioInstance.src === this.recordedAudioUrls[index]) {
      this.audioInstance.pause(); // Pause the audio
      this.audioInstance.currentTime = 0; // Reset the playback position to the start
      this.playingStates[index] = false; // Update the playing state for the index
      console.log(`Stopped playing sound for index ${index}`);
    } else {
      console.warn(`No audio is playing or the audio source does not match for index ${index}`);
    }
  }


  playRecording(i: number) {

    // Toggle play/pause for the specific index
    if (this.audioInstance && !this.audioInstance.paused && this.playingStates[i]) {
      // Pause the audio if it is currently playing
      this.audioInstance.pause();
      this.playingStates[i] = false; // Update playing state for the current index
    } else if (this.recordedAudioUrls && this.recordedAudioUrls[i]) {
      // Create a new audio instance if not already initialized or play a new audio
      if (!this.audioInstance || this.audioInstance.src !== this.recordedAudioUrls[i]) {
        this.audioInstance = new Audio(this.recordedAudioUrls[i]);
        this.audioInstance.onended = () => {
          this.playingStates[i] = false; // Reset the playing state when the audio ends
        };
      }
  
      // Play the audio
      this.audioInstance.play();
      this.playingStates[i] = true; // Update playing state for the current index
    }
  }



  





}

